<template>
  <div class="pay_pick_page">
    <div class="page_top_img_container life_bk_block">
      <div class="content_container">
        <div class="mmc_title_with_line">上门自提</div>
      </div>
      <div class="lineH_desc_16">上门自提注意事项：  </div>
      <div class="lineH_desc_16">自提时间：周一至周五，09:00 － 18:00（如遇国家法定节假日，则以智众医疗发布放假时间为准，请大家届时关注）；</div>
      <div class="lineH_desc_16">到达自提点后，我们将为您保留三天，超过三天不上门提货，则视为默认取消订单；  </div>
      <div class="lineH_desc_16">钱、货需客户当面点清，离开提货前台后智众医疗将不再对钱、货数量负责；  </div>
      <div class="lineH_desc_16">货物价保需客户在自提当场提出，离开提货前台后智众医疗不再对自提货物提供价保服务；  </div>
      <div class="lineH_desc_16">普通发票：由库房开具发票，随包裹一同发送，自提点不提供开票和换票服务。</div>
      <div class="lineH_desc_16">提货地址：中国（上海）自由贸易试验区世纪大道1600号7层1-2，6A单元</div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
